import { useQuery } from '@apollo/client'
import moment from 'moment'
import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { SkyButton } from '../../Components/Buttons'
import { GET_DRIVERS_BY_FLEET_OWNER } from '../../Services/cabapi/fleetggl'
import { MyContext } from '../../utils/context/TempAuth'
import { FaInbox } from 'react-icons/fa'
import { getTransactionStatus } from '../../utils/datesfunctions'

const ManageDriver = () => {
  const navigate = useNavigate()
  const { userData } = useContext(MyContext)

  const today = moment() // Get the current date

  const { loading, error, data, refetch } = useQuery(
    GET_DRIVERS_BY_FLEET_OWNER,
    {
      variables: {
        fleetOwnerId: userData?.fleetId,
      },
    }
  )

  useEffect(() => {
    refetch()
  }, [])

  if (loading) {
    return <div>Loading...</div>
  }
  if (error) {
    return <div>Error: {error.message}</div>
  }

  return (
    <div>
      <div className="w-full  h-full bg-white p-4 shadow rounded-md text-start">
        <div className="sticky top-0">
          <div className="text-stone-500 text-xl font-bold mb-4">
            Manage Driver
          </div>
          <div className="my-3 flex justify-end">
            <SkyButton
              label={'Add Driver'}
              onClick={() => navigate('add-driver')}
            />
          </div>
          <div className="mt-4 w-full overflow-x-auto h-[70vh]">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-collapse border border-gray-300">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0 z-10">
                <tr>
                  <th className="px-6 py-3 border border-gray-300">Name</th>
                  <th className="px-6 py-3 border border-gray-300">
                    Mobile Number
                  </th>
                  <th className="px-6 py-3 border border-gray-300">Email</th>
                  <th className="px-6 py-3 border border-gray-300">
                    Permanent Address
                  </th>
                  <th className="px-6 py-3 border border-gray-300">
                    Birthdate
                  </th>
                  <th className="px-6 py-3 border border-gray-300">
                    Tr Expiry
                  </th>
                  <th className="px-6 py-3 border border-gray-300">Menu</th>
                  <th className="px-6 py-3 border border-gray-300">Verify</th>
                </tr>
              </thead>
              <tbody>
                {data?.getDriverByFleetOwner?.length === 0 ? (
                  <tr className="bg-white">
                    <td
                      className="px-2 py-4 border border-#cedbe2-800 text-center"
                      colSpan="13"
                    >
                      <div className="flex justify-center items-center h-16">
                        <FaInbox className="mr-2" />
                        No data found
                      </div>
                    </td>
                  </tr>
                ) : (
                  data?.getDriverByFleetOwner?.map((items, index) => {
                    const { status, daysRemaining, animate } =
                      getTransactionStatus(items?.trDate)
                    return (
                      <tr className="bg-white border-b" key={index}>
                        <td className="px-6 py-4 border border-gray-300">
                          {items?.firstName} {items?.middleName}{' '}
                          {items?.lastName}
                        </td>
                        <td className="px-6 py-4 border border-gray-300">
                          {items?.mobileNumber}
                        </td>
                        <td className="px-6 py-4 border border-gray-300">
                          {items?.email}
                        </td>
                        <td className="px-6 py-4 border border-gray-300">
                          {items?.permanentAddress}
                        </td>
                        <td className="px-6 py-4 border border-gray-300">
                          {moment(items?.birthDate).format('MMM DD YYYY')}
                        </td>
                        <td className="px-6 py-4 border border-gray-300">
                          <div className="">
                            {moment(items?.trDate).format('MMM DD YYYY')}
                            {status === 'expired' ? (
                              // If expired
                              <div className="flex gap-1 items-center">
                                <div>
                                  <div className="w-2 h-2 rounded-full bg-red-700" />
                                </div>
                                <div>
                                  <span className="text-red-400 text-[12px] whitespace-nowrap">
                                    TR has expired
                                  </span>
                                </div>
                              </div>
                            ) : status === 'expiringSoon' ? (
                              <div className="flex gap-1 items-center">
                                <div>
                                  <div
                                    className={`w-2 h-2 rounded-full bg-red-700 ${
                                      animate ? 'animate-blink' : ''
                                    }`}
                                  />
                                </div>
                                <span className="text-red-400 text-[12px] whitespace-nowrap">
                                  Renew tr in {daysRemaining}{' '}
                                  {daysRemaining === 1 ? 'day' : 'days'}
                                </span>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </td>
                        <td className="px-6 py-4 border border-gray-300">
                          <SkyButton
                            label={'Edit'}
                            onClick={() => {
                              navigate('/manage-driver/edit-driver', {
                                state: items,
                              })
                            }}
                          />
                        </td>
                        <td className="px-6 py-4 border border-gray-300">
                          {items?.isVerified ? 'Verified' : 'Un-Verified'}
                        </td>
                      </tr>
                    )
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ManageDriver
